import { useLocation } from 'react-router-dom';
import { SelectSwitcher } from '../generic/switcher/SelectSwitcher';
import { useState } from 'react';
import { CaseList } from './CaseList';
import { ButtonSwitcherFour } from '../generic/switcher/ButtonSwitcherFour';

const switchPositionList = [
  { id: '0', value: '', label: 'Type of applications', placeholder: true },
  { id: '1', value: 'adalo', label: 'Adalo' },
  { id: '2', value: 'uniqueApplications', label: 'Unique Applications' },
  { id: '3', value: 'popularApps', label: 'Popular apps' },
  { id: '4', value: 'successStories', label: 'Success Stories' },
];

const getTabTypeFromstring = (option: string) => {
  switch (option) {
    case 'popularApps':
      return 'popularApps';
    case 'uniqueApplications':
      return 'uniqueApplications';
    case 'adalo':
      return 'adalo';
    case 'successStories':
      return 'successStories';
    default:
      return 'adalo';
  }
};

const labels = {
  first: {
    title: 'Adalo',
    value: 'adalo',
  },
  second: {
    title: 'Unique Applications',
    value: 'uniqueApplications',
  },
  third: {
    title: 'Popular apps',
    value: 'popularApps',
  },
  fourth: {
    title: 'Success Stories',
    value: 'successStories',
  },
};

export const TypesOfApplications = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const typeofapplications = queryParams.get('typeofapplications');
  const [switchPosition, setSwitchPosition] = useState<string>(
    typeofapplications !== null
      ? getTabTypeFromstring(typeofapplications)
      : 'successStories'
  );
  return (
    <div className="pb-16">
      <div className="flex justify-center">
        <SelectSwitcher
          switchPosition={switchPosition}
          setSwitchPosition={setSwitchPosition}
          switchPositionList={switchPositionList}
        />
        <ButtonSwitcherFour
          switchPosition={switchPosition}
          setSwitchPosition={setSwitchPosition}
          labels={labels}
          searchWord="typeofapplications"
        />
      </div>
      <CaseList />
    </div>
  );
};
